import { render, staticRenderFns } from "./FullLoader.vue?vue&type=template&id=5bb440b2&"
import script from "./FullLoader.vue?vue&type=script&lang=js&"
export * from "./FullLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports